import { render, staticRenderFns } from "./section-recent.vue?vue&type=template&id=a6817b92&"
import script from "./section-recent.vue?vue&type=script&lang=js&"
export * from "./section-recent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports